import firebase from 'firebase/app';
import { filterDocuments } from '@/service/documentFilters';

const state = {
  lines: [],
};

const mutations = {
  LOAD_DATA(state, data) {
    state.lines = data;
  },
};

const actions = {
  get_all_lines: async () => {
    const { docs: lines } = await firebase.firestore().collection('ssl').get();
    const fDocs = filterDocuments(lines);
    const linesData = fDocs.map((doc) => ({ id: doc.id, ...doc.data() }));

    return linesData;
  },
  get_lines: async ({ commit, rootGetters }) => {
    try {
      const { docs: lines } = await firebase
        .firestore()
        .collection('ssl')
        .get();

      const fDocs = filterDocuments(lines);
      const organizationIntegrations = rootGetters['auth/get_org'].integrations;
      const linesData = fDocs.map((doc) => ({ id: doc.id, ...doc.data() }));
      const filteredLinesData = linesData.filter((line) => !line.integration);
      const linesByIntegration = linesData.filter((line) =>
        organizationIntegrations?.find(
          ({ id: oId }) => line.integration?.id === oId
        )
      );

      commit('LOAD_DATA', [...filteredLinesData, ...linesByIntegration]);
    } catch (error) {
      commit('LOAD_DATA', []);
    }
  },
};

const getters = {
  get_lines(state) {
    return state.lines;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
